export default "__VITE_ASSET__q4mPHJEp__"